import React, { useEffect, memo } from 'react';
import { configureClientInstrumentation } from '../lib/client-instrumentation';
import { initTrackingScripts } from '../lib/tracking-scripts';
import { attachAnalyticsListeners } from '@spotify-internal/touchdown-analytics';
import Page from '../../shared/components/Page';

export type SpotiDataType = typeof window.SPOTI_DATA;

const App = (props: SpotiDataType) => {
  const {
    baseElement,
    useInstrumentation,
    user,
    language,
    pageName,
    resourceName,
    market,
    country,
    forceOneTrust,
    pageData,
    direction,
    embedded,
  } = props;

  const pageProps = { market, direction, user, pageData, embedded, language };

  useEffect(() => {
    if (useInstrumentation) {
      configureClientInstrumentation();
    }
  }, [useInstrumentation]);

  useEffect(() => {
    if (language) {
      initTrackingScripts({
        forceOneTrust,
        market,
        language,
        loggedIn: user.authenticated,
      });
    }
  }, [forceOneTrust, market, language, user.authenticated]);

  useEffect(() => {
    attachAnalyticsListeners({
      analyticsRoot: baseElement,
      isAuthenticated: user.authenticated ?? false,
      pageName,
      resourceName,
      language,
      countryCode: country ?? '',
      eventParams: pageData.eventParams ?? {},
    });
  }, [
    baseElement,
    user.authenticated,
    pageName,
    resourceName,
    language,
    country,
    pageData.eventParams,
  ]);

  return <Page {...pageProps} />;
};

export default memo(App);
